import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { LoadingWidget } from '../../../../widgets';
import { allPerfilesAction } from '../PerfilesAction';

const SelectFieldPerfilesComponent = ({
  onChange,
  id,
  data,
  value,
  isAll = true,
  idsIgnore = [],
  required = false,
  error = false,
}) => {
  const dispatch = Redux.useDispatch();

  const perfilesStore = Redux.useSelector((state) => state.perfiles);

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && perfilesStore.all.length === 0) {
        await allPerfilesAction(dispatch, null);
        setItems(perfilesStore.all);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let rowsData = [];
    if (idsIgnore.length > 0) {
      perfilesStore.all.forEach((el) => {
        const existSeletc = idsIgnore.some((item) => item === el.id);
        if (!existSeletc) rowsData.push(el);
      });
      setItems(rowsData);
    } else {
      setItems(data || perfilesStore.all);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [idsIgnore]);

  return perfilesStore.loadingAll ? (
    <LoadingWidget isLoading={true} />
  ) : (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${id}`}>{CONST.perfiles.label}</InputLabel>
      <Select
        id={CONST.ID}
        value={value}
        labelId={`label_${id}`}
        label={CONST.perfiles.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isAll && (
          <MenuItem key={`${id}-000-item`} value={null}>
            TODOS
          </MenuItem>
        )}
        {items.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectFieldPerfilesComponent;
